import script from "./goodsManage.vue?vue&type=script&setup=true&lang=js"
export * from "./goodsManage.vue?vue&type=script&setup=true&lang=js"

import "./goodsManage.vue?vue&type=style&index=0&id=ea858a3e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea858a3e"]])

export default __exports__